// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e257ca38","977":"2d6e387a"}[chunkId] + ".chunk.js";
};